import styled from 'styled-components';
import mainColors from '../../main-colors';
import sizeStandards from '../../size-standards';

const DropdownWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'items',
})`
  position: relative;

  .parent-element {
    /* all: unset;
    background: transparent;
    border: none;
    padding: 0;
    font: inherit;
    color: inherit;
    cursor: pointer; */
    display: contents;
  }

  .menu-item {
    list-style-type: none;
    margin: 2px 0;

    > * {
      padding: 4px;
      text-align: center;
      color: ${mainColors.text_color};
      text-decoration: none;
      font-size: ${sizeStandards.font.SM}px;

      &:hover {
        background-color: ${mainColors.main_color};
        border-radius: 8px;
        box-shadow: 0px 0px 10px 0px ${mainColors.text_color};
      }
    }
  }

  .dropdown-menu-container {
    position: relative;
    top: -15px;
    left: -15px;
    z-index: 2;
  }

  .dropdown-menu {
    white-space: nowrap;
    position: absolute;
    top: 0px;
    left: 4px;
    border-radius: 8px;
    padding: 8px;
    background: ${mainColors.main_color_rgba(0.6)};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

export default DropdownWrapper;
